import React, { useState } from 'react'
import messages from './messages'
import { useIntl, FormattedMessage } from 'react-intl'
import { Modal, Button, TextArea } from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

export default NiceModal.create(({ fileIds, task }) => {
  const [loading, setLoading] = useState(false)
  const { formatMessage } = useIntl()
  const modal = useModal()

  const [note, setNote] = useState('')

  const onSubmit = (event) => {
    event.preventDefault()
    setLoading(true)

    const body = new FormData()
      body.append('taskId', task?.uid);
      body.append('msg', note);
      body.append('fileIds', fileIds);

    fetch(`/ordertask/deliverSelectedFilesAsZip.html`, {
      method: 'POST', body
    })
    .then((response) => response.text())
    .then((response) => {
      if (response == 'OK') {
        toastr.success(formatMessage(messages.success))
        modal.resolve()
        modal.remove()
        setLoading(false)
      } else {
        toastr.error(formatMessage(messages.error));
      }
    })
    .catch((error) => toastr.error(error))
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      title={formatMessage(messages.title)}
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <TextArea
          optional
          label={formatMessage(messages.customerMessageLabel)}
          placeholder={formatMessage(messages.customerMessagePlaceholder)}
          value={note}
          onChange={(event) => setNote(event.target.value)}
        />

        <ol className="list-decimal list-inside text-sm">
          <FormattedMessage
            {...messages.sideEffects}
            values={{
              li: (chunks) => <li className="">{chunks}</li>,
            }}
          />
        </ol>

        <div className="flex justify-end">
          <Button type="submit" size="sm" disabled={loading}>
            { loading ? (
              <FormattedMessage {...messages.loading} />
            ) : (
              <FormattedMessage {...messages.submit} />
            ) }
          </Button>
        </div>
      </form>
    </Modal>
  )
})
